import axios from "axios";
import { IDashboardData, IServiceResult } from "../../Models/Models";
import { IHome } from "../index";

export class HomeAxios implements IHome {
    public GetDashboardData(): Promise<IServiceResult<IDashboardData>> {
        const promise = new Promise<IServiceResult<IDashboardData>>(
            (resolve, reject) => {
                axios.get<IServiceResult<IDashboardData>>("/Insights/Data", {}).then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            }
        );
        return promise;
    }
}
